var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 16",
    role: "img",
    "aria-label": "Visa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 16,
    rx: 2,
    fill: "#1A1F71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.2 11.2h-2.1l1.3-7.5h2.1L19.2 11.2zm8.5-7.3c-.4-.2-1.1-.3-2-.3-2.2 0-3.7 1.1-3.7 2.8 0 1.2 1.1 1.9 2 2.3.9.4 1.2.7 1.2 1.1 0 .6-.7.9-1.4.9-.9 0-1.4-.1-2.2-.5l-.3-.1-.3 1.9c.5.2 1.4.4 2.4.4 2.3 0 3.8-1.1 3.8-2.9 0-1-.6-1.7-1.9-2.3-.8-.4-1.3-.6-1.3-1 0-.3.4-.7 1.2-.7.7 0 1.2.1 1.6.3l.2.1.3-1.8zm6.2-.2h-1.6c-.5 0-.9.1-1.1.6l-3.2 6.9h2.2l.5-1.3h2.7l.3 1.3h1.9L33.9 3.7zm-2.4 4.4l1.1-3 .6 3h-1.7zM16.5 3.7l-2 7.5h-2l2-7.5h2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4f939487f135c7f10780df6c58909a0f.svg";
export { ForwardRef as ReactComponent };